// extracted by mini-css-extract-plugin
export default {"fullContainer":"TodoCard_fullContainer__RDG89"};